import React, { Component } from "react";
import "./header/Header.css"; 
import "../scss/general.css"
//import Moment from "moment";
import ModalLogin from './ModalLogin';
import Mymodal from './modalleave';
import config from '../config';
import Modal from "react-bootstrap/Modal"
import modallogo from "./images/loader.gif";
import BusyModal from "./modalwait";
import logo from "./images/loading.gif";
import Cookies from "universal-cookie";
//import Helmet from 'react-helmet';
import "../scss/radio.scss" ;
const  axios = require("axios");
const cookies = new Cookies();
const columns = [
{
    field: "name",
    header: "Name",
    width: "200px",
},
{
    field: "designation",
    header: "Designation",
    width: "200px",
},
];

const initialState={
  input:{},
  myitems:[],
  authority:[],
  isLoaded: false,
  options:false,
  edsubmit:true,
  div1:"block",
  div2:"none",
  optionValue:"C",
  toname:"",
  toemail:"",
  error:"",
  errorcss:"labelerror",
  textreason:"",
  disDIV:"none",
  authority:[],
  isOpen:false,
//  authorityD:[{"emp_id":"1","name":"CE","designation":"Chief Executive",email:"Khalil.Sattar@KandNs.com"},{"emp_id":"2","name":"ED","designation":"Executive Director",email:"Adil.Sattar@KandNs.com"}],
  ErrMsg:<img src={logo} alt="Error"/>,
  ErrMsg2:"",
  fstatus:0,
  getItems:[],
  St:0 ,
  mylocation: [],
  mydepartments:[],
  employeelist:[],
  islocation:false,
  locationcode:"00",
  departmentcode:0,
  employeecode:"0",
  locationname:"",
  departmentname:'',

  inputList:[{ItemName: "", qty:0}]  
}
class PR extends Component
{
  constructor(props)
  {
      super(props);
      this.state=initialState;
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleoptionclick = this.handleoptionclick.bind(this);
      this.handleClear = this.handleClear.bind(this);
      this.handleTextChange = this.handleTextChange.bind(this);
      this.optionG = this.optionG.bind(this);
      //this.optionD = this.optionD.bind(this);
      this.ErrHandler = this.ErrHandler.bind(this);
      this.handleAddClick=this.handleAddClick.bind(this);
      this.handleRemoveClick=this.handleRemoveClick.bind(this);
      this.handleInputChange1=this.handleInputChange1.bind(this);
      this.handleSelectChange=this.handleSelectChange.bind(this);
      this.handleSelectChangedepartment=this.handleSelectChangedepartment.bind(this);

  }
  ErrHandler(){
      this.setState({...initialState});
      this.componentDidMount();
  } 
  handleAddClick(){
    let inputlist = this.state.inputList;
    inputlist.push({ItemName:"",qty:0});
    console.log(inputlist);
    this.setState({inputlist});
//    this.setState({inputList:[{ ItemName: "", qty:0}]});
  }
  handleSelectChangeemployee=(e)=>{
    this.setState({employeecode:e.target.value,disDIV:"",fstatus:1});
  }
  handleSelectChange=(e)=>{    
    this.setState({locationcode:e.target.value,locationname:e.nativeEvent.target[e.target.selectedIndex].text,myitems:[],divxls:'none'});
}
handleSelectChangedepartment=(e)=>{        
  this.setState({employeelist:[],departmentcode:e.target.value,departmentname:e.nativeEvent.target[e.target.selectedIndex].text,myitems:[],divxls:'none'});

      axios.all([
        axios({
            method: 'post',
            url: cookies.get("phpclass")+'/index.php/user/get_employees_LD/'+this.state.locationcode+"/"+e.target.value,
            headers: {'Content-Type': 'multipart/form-data'}
            }),
        axios({
            method: 'post',
            url: cookies.get("phpclass")+'/index.php/user/LeaveAuthority_loc/'+this.state.locationcode+"/"+e.target.value,
            headers: {'Content-Type': 'multipart/form-data'}
            })
          ])
         .then(axios.spread((response3,response1)=> {
            document.body.style.cursor="default";
            console.log(response3.data);
            if(response3.data === "0")
            {
              document.body.style.cursor="default";
              this.setState({isOpen:false,St:0,ErrMsg2:<Mymodal Type="1" handler = {this.handleClear} Title="Error" Body="No data found for this department."/>});
            }         
            else 
            {   
              document.body.style.cursor="default";
              this.setState({employeelist:response3.data,authority:response1.data});
            }
          }))
          .catch((response)=> {
            document.body.style.cursor="default";
            this.setState({isOpen:false,St:0,ErrMsg2:<Mymodal Type="1" Title="Failed" handler={this.handleClear} Body="Transaction is not possible this time, please try after few minutes"/>});
          })

}

   handleRemoveClick(index){
    let list = this.state.inputList;
    list.splice(index, 1);
    this.setState({list});
  }
  // handle input change
  handleInputChange1=(e, index)=>{
      const { name, value } = e.target;
      const list = this.state.inputList;
      list[index][name] = value;
      this.setState({list});
//      console.log(list);
  }
  optionG(e){
      this.setState({ toname:this.state.authority[e.target.value].name,toemail:this.state.authority[e.target.value].email,edsubmit:false});
  }
/*  optionD(e){
      this.setState({toname:this.state.authorityD[e.target.value].name,toemail:this.state.authorityD[e.target.value].email,edsubmit:false});
  }*/
  handleTextChange(e){
      this.setState({textreason:e.target.value});
  }
  componentDidMount()
  {
    this.setState({isLoaded: false});
    axios.all([
      axios({
          method: 'post',
          url: cookies.get("phpclass")+'/index.php/user/get_location/0',
          headers: {'Content-Type': 'multipart/form-data'}
      }),
      axios({
          method: 'post',
          url: cookies.get("phpclass")+'/index.php/user/get_departments/0',
          headers: {'Content-Type': 'multipart/form-data'}
      })
  ])
  .then(axios.spread((response,response1)=> {
           if(response.data === 2)
          {
              document.body.style.cursor="default";
              this.setState({ErrMsg:<img src={logo} alt="Error"/>,islocation:false,isLoaded:true});
          }
          else
          {
              document.body.style.cursor="default";
              this.setState({
              locationcode: response.data[0]["l_code"],
              mydepartments:response1.data,
              departmentcode:response1.data[0]["dept_id"],
              departmentname:response1.data[0]["department"],
              islocation: true,
              isLoaded:true,
              ErrMsg:"",
              mylocation: response.data,
              lcode:response.data[0]["l_code"],
              locationname:response.data[0]["location"]
              })
          };
      }))
      .catch(()=> {
          document.body.style.cursor="default";
          this.setState({ErrMsg:<img src={logo} alt="Error"/>});
      });    
}    
    handleoptionclick=(e)=>
    {
      let evalue=e.target.value;
      if(evalue === "G")
        this.setState({optionValue:evalue, div1:"none",div2:"block"});
      if(evalue === "C")
        this.setState({optionValue:evalue,div1:"none",div2:"block"});
    }

    cur=(num)=> {
      let cnum=parseInt(num,0);
      if(num > 0)
        return num.toFixed(1).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      else
        return "-"
    }


    handleClear()
    {
      this.setState({ErrMsg2:""});
      if(this.state.St === 1)
      {
        this.setState({...initialState});
        this.componentDidMount();
      }
    }
    handleSubmit()
    {
      let countinputlist = this.state.inputList.length;
      let textreason = this.state.textreason.length;
      let fstatus = this.state.fstatus;

      if(countinputlist == 0)
      {
        fstatus=0;
        this.setState({fstatus:0, isOpen:false,St:0,ErrMsg2:<Mymodal Type="1" handler = {this.handleClear} Title="Error" Body="Please enter the detailed item description and required quanity."/>});
      }
      if(textreason < 10)
      {
        fstatus=0;
        this.setState({fstatus:0,isOpen:false,St:0,ErrMsg2:<Mymodal Type="1" handler = {this.handleClear} Title="Error" Body="Please enter the reason in detail."/>});
      }


      if(fstatus===1)
      {
        this.setState({ErrMsg2: <BusyModal />});
{/*}          axios({
            method: 'post',
            url: cookies.get("phpclass")+'/index.php/user/Submitleave2/',
            data: this.state.input,
            headers: {'Content-Type': 'multipart/form-data'}
          })
          .then((response)=> {
            document.body.style.cursor="default";
            console.log(response.data);
            if(response.data === "2")
            {
              document.body.style.cursor="default";
              this.setState({isOpen:false,St:1,ErrMsg2:<Mymodal Type="0" handler = {this.handleClear} Title="Success" Body="Your request for leave approval sent successfully."/>});
            }         
            else 
            {   
              document.body.style.cursor="default";
              this.setState({isOpen:false,St:0, ErrMsg2:<Mymodal Type="1" Title="Failed" handler = {this.handleClear} Body="There might be a connection issue. Please try again."/>});
            }
          })
          .catch((response)=> {
            document.body.style.cursor="default";
            this.setState({isOpen:false,St:0,ErrMsg2:<Mymodal Type="1" Title="Failed" handler={this.handleClear} Body="Transaction is not possible this time, please try after few minutes"/>});
          });*/}
      }
      else
      {
        document.body.style.cursor="default";
{/*}        this.setState({isOpen:false,St:0,ErrMsg2:<Mymodal Type="1" Title="Failed" handler={this.handleClear} Body="Please press the <Proceed> button to update the leave balance."/>});*/}
    
      }
    }  
 render()
 {
    let inputList=this.state.inputList;
    let isLoaded =this.state.isLoaded;
    let islocation=this.state.islocation;
    let employeelist = this.state.employeelist;    
    let litems = this.state.mylocation;
    let ditems=this.state.mydepartments;
    let items=this.state.authority;
/*    let countinputlist = this.state.inputList.length;
    let textreason = this.state.textreason.length;

    if(countinputlist == 0)
    {
      this.setState({isOpen:false,St:0,ErrMsg2:<Mymodal Type="1" handler = {this.handleClear} Title="Error" Body="Please enter the detailed item description and required quanity."/>});

      return
    }
    if(textreason < 10)
      {
        this.setState({isOpen:false,St:0,ErrMsg2:<Mymodal Type="1" handler = {this.handleClear} Title="Error" Body="Please enter the reason in detail."/>});
  
        return
      }
  */
    if (!isLoaded && !islocation  ) 
      {
        return(
          <div className={config.changeDivClass}>
            <div className="center">
              {this.state.ErrMsg}
            </div>
        </div>
        );
      } 
      else if(isLoaded && !islocation)
      {
        return(
        <div className={config.changeDivClass}>
        <div className="center">
           {this.state.ErrMsg}
        </div>
        </div>);
      }
      else if(isLoaded && islocation )
      {    

      return (
        <div className="container1">
        <br></br>                             
        <div style={{width:"100%",textAlign:"center",align:"center"}} >
        <br></br>
        <div className="inner-profile">
        <h5>Purchase Requisition Form</h5>
            <div style={{width:"50%",marginLeft:15}}>
            <div className="form-group row">
            <table style={{width:"80%",marginTop:"15px"}}>
            <thead></thead>
            <tbody>
                <tr style={{height:40}}>
                <td><input type="radio" className="radio" value="G" name="leaveb" disabled={this.state.options} onChange={this.handleoptionclick} id="Annual"/><label htmlFor="Annual" ><b>General items</b></label></td>
                <td><input type="radio" className="radio" value="C" name="leaveb" defaultChecked disabled={this.state.options} onChange={this.handleoptionclick} id="Casual"/> <label htmlFor="Casual" ><b>Computer & accessories</b></label></td>
                </tr>
            </tbody>
            </table>
            </div>

            <div className="form-group row">
                <label style={{textAlign:"left"}}>Location:</label>
                <select id="location" name="location" style={{height:30,borderRadius:15}} onChange={this.handleSelectChange} >
                    {litems.map((result,i)=>{
                      return(
                        <option value={result.l_code} key={i}  >{result.location}</option>
                      );
                    })}
                </select>
            </div>
            <div className="form-group row">
                <label style={{textAlign:"left"}}>Department:</label>
                <select id="department" name="department" placeholder="Select department" style={{height:30,borderRadius:15}} onChange={this.handleSelectChangedepartment} >
                <option value={0}   >Select department</option>

                    {ditems.map((result,i)=>{
                      return(
                        <option value={result.dept_id} key={i}  >{result.department}</option>
                      );
                    })}
                </select>
            </div>
            <div className="form-group row">
                <label style={{textAlign:"left"}}>For user:</label>
                <select id="foruser" name="foruser" style={{height:30,borderRadius:15}} onChange={this.handleSelectChangeemployee} >
                <option value={0}>Select employee</option>

                  {employeelist.map((result,i)=>{
                      return(
                        <option value={result.emp_id} key={i}  >{result.name}</option>
                      );
                    })}
                  </select>
            </div>
            </div>
            <br></br>
            <table style={{width:"80%",textAlign:"left"}}>
              <thead>
                <tr>
                  <th className="mth" rowSpan="2"><p style={{textAlign:'center'}}>Description</p></th>
                  <th className="mth" rowSpan="2"><p style={{textAlign:'center'}}>Quantity</p></th>
              </tr> 
            </thead>
            <tbody>


            {inputList.map((x, i) => {
            return (
            <tr key={i}>
                <td className="mtd">
                    <textarea name="ItemName" cols="66" rows={5}
                      maxLength={250}
                      value={x.ItemName} 
                      onChange={e => this.handleInputChange1(e,i)}
                      style={{border:"none"}}/>
                </td>
                <td className="mtd">
                    <input type="number" style={{width:77, border:'none',textAlign: 'right' }}
                        name="qty"
                        value={x.qty}
                        onChange={e => this.handleInputChange1(e,i)}
//                        onBlur={e => handleInputChange(e, i)}
//                        onFocus={ e => handleFocus(e)}
                    />
                </td>
                <td style={{border:"none"}}>
                    {inputList.length > 1 && <button
                        className="mr10"
                        onClick={()=>this.handleRemoveClick(i)}>X</button>}
                </td>
                <td style= {{border:"none"}}>
                    {inputList.length - 1 === i && <button onClick={this.handleAddClick}>+</button>}
                </td>
            </tr>
      );
    })}
    </tbody>
    </table>


            <table style={{width:"80%",textAlign:"left"}}  >
              <thead >
              </thead>
              <tbody >
              <tr>
                <td colSpan="7">
                  <label htmlFor="story" ><b>Reason or Purpose:</b></label>
                  <div width="100%">
                    <textarea name="textValue" title="Reason or Purpose"  onChange={this.handleTextChange} style={{width:"100%", height:"100px"}} />
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan="7"><b>Send for endorsement to;</b></td>
              </tr>
              <tr>
                <td colSpan="7" >
                <div style={{width:"100%",textAlign:"left", height:"150px",overflow:"auto",border:"gray solid 1px", float:"left",pointerEvents:this.state.disDIV}} id="control5">
                  <table style={{width:"100%",marginLeft:"5p"}} >
                  <tbody>
                    {items.map((result ,i) => {
                    return (
                      <tr className="trc" key={i}>
                        <td style={{width:"95%",paddingLeft:"5px"}}><input  id={result.name} type="radio" className="radio" value={i} name="inputopt" onChange={this.optionG}/><label className="lebel2" htmlFor={result.name}>{result.name}</label></td>
                      </tr>
                    )})}
                  </tbody>
                  </table>
                </div>
                </td>
              </tr>
              </tbody>
            </table>
            <br/>
            <div style={{paddingTop:"2px", width:"100%",textAlign:"center"}} >
                <button onClick={this.handleSubmit} className="btn btn-secondary active" disabled={this.state.edsubmit}>Submit</button>
                <div style={{width:"5px", height:"auto", display:"inline-block"}}/>
                  <button onClick={this.handleClear} className="btn btn-secondary active">Clear</button>
            </div>
          </div>
        </div>
        {this.state.ErrMsg2}
        <Modal show={this.state.isOpen}  animation="false" centered backdrop="static" size="sm">
        <Modal.Body><img src={modallogo} width="30px" height="30px"/><span style={{PaddingLeft:"15px"}}>Please wait...</span></Modal.Body>
        </Modal>
      </div>
    );
  }
}
}
export default PR;